import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.scss';
import 'antd/dist/antd.min.css';

const OktaWrapper = lazy(() => import('./OktaWrapper'));

const App: React.FC = (): JSX.Element => {
  
  return (
    <Router basename={'/'}>
      <Suspense fallback={<div>Loading...</div>}>
        <OktaWrapper />
      </Suspense>
    </Router>
  );
};

export default App;
